<script setup lang="ts">
import { ref } from "vue";
import AnimateHeight from "vue-animate-height";
import LoadingLogoSpinner from "@/components/Reusables/Loading/LoadingLogoSpinner.vue";

defineProps<{
  thinking: string;
  isStreaming: boolean;
}>();

const expanded = ref(false);
</script>

<template>
  <div class="chat-thinking-block mb-px-8 rounded-8 overflow-hidden border">
    <button
      type="button"
      class="chat-thinking-button gap-px-8 px-px-12 py-px-8 min-h-px-40 flex w-full items-center"
      :aria-expanded="expanded"
      @click="expanded = !expanded">
      <!-- Same spinning gaiup mark, at the same size, as ChatThinkingIndicator: this block takes over
           from that indicator the moment the first reasoning chunk lands, and the 8px pulse dot it
           replaces made the loading signal look like it had stopped mid-run (RTLCA-5811).
           aria-hidden so the spinner's own status region stays out of the button's accessible name —
           the visible "Thinking" label already says what the block is. -->
      <LoadingLogoSpinner
        v-if="isStreaming"
        aria-hidden="true"
        class="flex shrink-0 items-center"
        logo-class="icon-lg" />
      <span class="chat-thinking-label t-caption-bold">Thinking</span>
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="chat-thinking-meta icon-xs duration-fast ease-standard ml-auto transition-transform"
        :class="{ 'rotate-180': expanded }" />
    </button>
    <AnimateHeight :height="expanded ? 'auto' : 0">
      <div class="chat-thinking-content px-px-12 pb-px-12 t-caption whitespace-pre-wrap">{{ thinking }}</div>
    </AnimateHeight>
  </div>
</template>
